// V9.17 · Foto do aluno por UPLOAD (painel, DNA Connect e app) — Emergent Object Storage.
import React, { useRef, useState } from 'react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { Camera, Loader2, UserRound } from 'lucide-react';
import api from '@/lib/api';

const src = (studentId, photoUrl) => {
  if (!photoUrl) return null;
  if (/^https?:\/\//i.test(photoUrl)) return photoUrl;          // legado (URL externa)
  return `${process.env.REACT_APP_BACKEND_URL}${photoUrl}`;
};

export const StudentPhotoUpload = ({ studentId, photoUrl, onUploaded, compact = false }) => {
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [preview, setPreview] = useState(null);
  const shown = preview || src(studentId, photoUrl);

  const send = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!studentId) return toast.error('Salve o cadastro antes de enviar a foto.');
    if (file.size > 8 * 1024 * 1024) return toast.error('A foto passa de 8 MB. Escolha uma menor.');
    const fd = new FormData();
    fd.append('file', file);
    setBusy(true);
    try {
      const { data } = await api.post(`/students/${studentId}/photo`, fd,
        { headers: { 'Content-Type': 'multipart/form-data' } });
      setPreview(URL.createObjectURL(file));
      onUploaded?.(data.photo_url);
      toast.success('Foto atualizada.');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Falha ao enviar a foto.');
    } finally { setBusy(false); }
  };

  return (
    <div className={`flex items-center gap-3 ${compact ? '' : 'mt-1'}`} data-testid="student-photo-upload">
      <div className="w-14 h-14 rounded-xl overflow-hidden bg-slate-100 border grid place-items-center shrink-0">
        {shown ? <img src={shown} alt="Foto do aluno" className="w-full h-full object-cover" data-testid="student-photo-preview" />
               : <UserRound className="w-6 h-6 text-slate-400" />}
      </div>
      <div>
        <input ref={fileRef} type="file" accept="image/*" capture="environment" className="hidden"
          onChange={send} data-testid="student-photo-input" />
        <Button type="button" variant="outline" size="sm" disabled={busy}
          onClick={() => fileRef.current?.click()} data-testid="student-photo-btn">
          {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Camera className="w-4 h-4 mr-1" />}
          {shown ? 'Trocar foto' : 'Enviar foto'}
        </Button>
        <p className="text-[10.5px] text-slate-400 mt-1">JPG, PNG, WEBP ou HEIC · até 8 MB</p>
      </div>
    </div>
  );
};

export default StudentPhotoUpload;
